import { AnomalyUI } from '@shared';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ApiAudit } from 'App';

export function useAnomalies(
  examSession?: string,
  auditUuid?: string
): UseQueryResult<AnomalyUI[]> {
  return useQuery(
    ['anomalies', examSession, auditUuid],
    () => ApiAudit.getAuditAnomalies(examSession, auditUuid),
    {
      select: (data) =>
        data?.map((anomaly) => ({
          uuid: anomaly.uuid,
          id: anomaly.id,
          start: anomaly.start,
          end: anomaly.end,
          label: anomaly.label,
          description: anomaly.comments.map((comment) => comment.comment),
          type: anomaly.anomalyTypeId,
        })),
      enabled: Boolean(auditUuid) && Boolean(examSession),
    }
  );
}
